<template>
  <button
    v-bind="$attrs"
    class="inline-flex h-6 items-center gap-1 rounded-full px-2.5 text-xs font-medium disabled:cursor-not-allowed"
    :class="themeClass"
    type="button"
  >
    <ui-spinner v-if="loading" no-spinner-background inline background="transparent" :spinner-color="spinnerColor" />
    <template v-else>
      <slot name="icon" />
      <slot />
    </template>
  </button>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { UiSpinner } from '..'

const props = withDefaults(
  defineProps<{
    theme?: 'blue' | 'gray' | 'brand' | 'white'
    loading?: boolean
  }>(),
  { theme: 'blue', loading: false },
)

const commonClasses = 'mix-blend-multiply'

const themeClass = computed(() => {
  if (props.theme === 'gray')
    return `${commonClasses} bg-gray-20 hover:bg-gray-30 text-gray-80 disabled:bg-gray-20 disabled:text-gray-50`
  if (props.theme === 'brand')
    return `${commonClasses} bg-button-primary-background hover:bg-button-primary-background-hover text-white disabled:bg-button-primary-background-disabled`
  if (props.theme === 'white') return 'bg-white hover:bg-gray-10 text-gray-80 disabled:bg-gray-10 disabled:text-gray-40'
  return `${commonClasses} bg-blue-20 hover:bg-blue-30 text-gray-80`
})

const spinnerColor = computed(() => {
  if (props.theme === 'gray') return 'gray-60'
  if (props.theme === 'brand') return 'white'
  if (props.theme === 'white') return 'gray-40'
  return 'active-primary'
})
</script>
